import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12.8 5.593v.312a6.888 6.888 0 0 1-7.026 6.877A7.072 7.072 0 0 1 2 11.7a5.032 5.032 0 0 0 .6.036 5 5 0 0 0 3.043-1.008 2.46 2.46 0 0 1-2.3-1.681A2.508 2.508 0 0 0 4.454 9a2.43 2.43 0 0 1-1.975-2.4v-.041a2.482 2.482 0 0 0 1.117.3 2.362 2.362 0 0 1-.763-3.21A7.034 7.034 0 0 0 7.9 6.169a2.395 2.395 0 0 1 2.4-2.952 2.475 2.475 0 0 1 1.8.762 4.985 4.985 0 0 0 1.567-.6 2.441 2.441 0 0 1-1.081 1.338A5 5 0 0 0 14 4.339a4.972 4.972 0 0 1-1.2 1.254Z';
const draw24px =
  'M20,8.49V9A11.47,11.47,0,0,1,8.29,20.47,11.83,11.83,0,0,1,2,18.66a8.39,8.39,0,0,0,1,.06A8.35,8.35,0,0,0,8.07,17a4.11,4.11,0,0,1-3.83-2.8,4.28,4.28,0,0,0,1.85-.07,4.05,4.05,0,0,1-3.29-4V10.1a4.17,4.17,0,0,0,1.86.5A3.94,3.94,0,0,1,3.39,5.25a11.74,11.74,0,0,0,8.45,4.2,4.06,4.06,0,0,1-.11-.92,4.12,4.12,0,0,1,7.1-2.73,8.21,8.21,0,0,0,2.61-1A4.06,4.06,0,0,1,19.64,7,8.41,8.41,0,0,0,22,6.4,8.28,8.28,0,0,1,20,8.49Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const LogoTwitterIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'logoTwitter'),
) as IconWithRender;

LogoTwitterIcon.displayName = 'LogoTwitterIcon';
LogoTwitterIcon.propTypes = Icon.propTypes;
LogoTwitterIcon.renderIcon = (props) => <LogoTwitterIcon {...props} />;
export default LogoTwitterIcon;
